import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Conversation } from 'src/app/shared/models/messaging/conversation';
import { User } from 'src/app/shared/models/security/user';
import { ConstantsService } from '../constant/constants.service';
import { GenericCrudService } from '../generic-crud.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { ListingResponse } from 'src/app/shared/models/listing/listing-response';
import { HttpParams } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class UserService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	importUsers(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'users.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.userBackUrl}/import`,
			`importUsers`,
			formData
		);
	}

	getAllUsers(): Observable<User[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.userBackUrl}/all`,
			'getAllUsers'
		);
	}

	getUsersMinimal(): Observable<User[]> {
		let queryParams = new HttpParams().append('light', true);
		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.userBackUrl}/all`,
			'getAllUsers',
			httpOptions
		);
	}

	getUsersPageable(
		page: number,
		size: number,
		search: string,
	): Observable<ListingResponse> {
		let queryParams = new HttpParams();
		queryParams = queryParams.append('page', page);
		queryParams = queryParams.append('size', size);
		if (search) {
			queryParams = queryParams.append('search', search);
		}

		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.userBackUrl}`,
			'getUsers',
			//httpOptions
		);
	}

	getAllUsersForMessaging(): Observable<User[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.messageUrl}/users`,
			'getAllUsersForMessaging'
		);
	}

	getAllExistingConversations(): Observable<Conversation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.userConvUrl}`,
			'getAllExistingConversations'
		);
	}

	getUserBackById(userId: number): Observable<User> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.userBackUrl}/get/${userId}`,
			'getUserBackById'
		);
	}

	getUserById(userId: number): Observable<User> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.userUrl}/get/${userId}`,
			'getUserById'
		);
	}

	addUser(user: User): Observable<User> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.userBackUrl}/add`,
			`addUser`,
			user
		);
	}

	updateUser(user: User): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.userBackUrl}/update/${user.id}`,
			`updateUser`,
			user
		);
	}

	deleteUser(userId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.userBackUrl}/delete/${userId}`,
			`deleteUser`
		);
	}

	changePassword(user: User): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.userBackUrl}/changePassword/${user.id}`,
			`updateUser`,
			user
		);
	}
	
}
